export enum YesOrNoOrNotApplicable {
    no = 'Nee',
    notApplicable = 'n.v.t.',
    yes = 'Ja',
}
